import { render, staticRenderFns } from "./wechatShareSetting.vue?vue&type=template&id=7d107ecd&scoped=true"
import script from "./wechatShareSetting.vue?vue&type=script&lang=js"
export * from "./wechatShareSetting.vue?vue&type=script&lang=js"
import style0 from "./wechatShareSetting.vue?vue&type=style&index=0&id=7d107ecd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d107ecd",
  null
  
)

export default component.exports